import { IAccount } from '@/model/domain/account'
import { IUser } from '@/model/domain/user'

export class EntityConditioner {
  static Account(account: Partial<IAccount>): Partial<IAccount> {
    return account
      ? {
          ...account,
          DisplayName: account.DisplayName
            ? account.DisplayName.trim()
            : account.DisplayName,
          Subdomain: account.Subdomain
            ? account.Subdomain.trim()
            : account.Subdomain,
        }
      : account
  }

  static User(user: Partial<IUser>): Partial<IUser> {
    return user
      ? {
          ...user,
          FirstName: user.FirstName ? user.FirstName.trim() : user.FirstName,
          LastName: user.LastName ? user.LastName.trim() : user.LastName,
          Title: user.Title ? user.Title.trim() : user.Title,
          Phone: user.Phone ? user.Phone.trim() : user.Phone,
        }
      : user
  }
}
